<template>
  <div class="bg">
    <!-- 搜索栏 -->
    <div class="top_search_part main_top_search">
      <div class="search_box">
        <div class="search_item">
          <el-input v-model="orderNum" :placeholder="$t('message.orderSearchPlaceholder')"></el-input>
        </div>
        <div class="search_item">
          <el-input v-model="orderSenderName" :placeholder="$t('message.orderSearchPlaceholder2')"></el-input>
        </div>
        <div class="search_item">
          <el-date-picker v-model="orderTime" align="center" type="datetimerange" range-separator=" - " :start-placeholder="$t('message.orderTimeStartHolder')" :end-placeholder="$t('message.orderTimeEndHolder')" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
        </div>
        <div class="search_item">
          <el-select v-model="orderStatus" :placeholder="$t('message.exportDatePlaceholder')" multiple collapse-tags>
            <el-option v-for="item in $t('message.orderStatusList')" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </div>
        <div class="search_item">
          <el-select v-model="searchAcount" :placeholder="$t('message.exportDatePlaceholder')" multiple collapse-tags>
            <el-option v-for="item in orderAcountList" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </div>
        <!-- <div class="search_item" disabled="display:none;">
          <el-input v-model="remark" :placeholder="$t('message.orderSearchPlaceholder4')"></el-input>
        </div> -->
        <div class="search_btn" @click="searchOrderNum">{{$t('message.searchBtnText')}}</div>
        <div class="search_btn" @click="importExcel">{{$t('message.importExcelTitle')}}</div>
        <div class="search_btn" @click="UpdateExcel">{{$t('message.UpdateExcelTitle')}}</div>
        <div class="search_btn" @click="exportOrders">{{$t('message.exportText')}}</div>
        <div class="search_btn" @click="PrintMulOrders">{{$t('message.PrintMulOrdersText')}}</div>
      </div>
    </div>
    <!-- 搜索栏 -->
    <!-- 列表 -->
    <!-- 订单管理列表 -->
    <div class="content">
      <div class="tableBox">
        <el-table id="orderList" :data="orderList" style="width: 100%" stripe size="small" header-cell-class-name="tableHeader" cell-class-name="tableBodyer" height="100%" @sort-change="sortChange" @selection-change="selectionChange">
          			  
		  <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column :label="$t('message.customTableTitle1')" prop="index" width="65"></el-table-column>
          <!-- <el-table-column :label="$t('message.HDS')" prop="HDS"></el-table-column>
          <el-table-column :label="$t('message.ShouJianYouBian')" prop="SJRYB"></el-table-column> -->
          <el-table-column :label="$t('message.ISCANDOOR')" prop="ISCANDOOR"></el-table-column>
          <el-table-column :label="$t('message.SENDTYPE')" prop="SENDTYPE"></el-table-column>
          <el-table-column :label="$t('message.CUSTOMERNO')" prop="CUSTOMERNO"></el-table-column>
          <el-table-column :label="$t('message.ShouJianPhone')" prop="SJRPHONE"></el-table-column>
          <el-table-column :label="$t('message.ShouJianYouBian')" prop="SJRYB"></el-table-column>
          <el-table-column :label="$t('message.ShouJianSheng')" prop="SJSHENG"></el-table-column>
          <!-- <el-table-column :label="$t('message.ShouJianShi')" prop="SJSHI"></el-table-column> -->
          <el-table-column :label="$t('message.ShouJianDiZhi')" prop="SJDIZHI"></el-table-column>
          <!-- <el-table-column :label="$t('message.ShouJianGongSi')" prop="SJGS"></el-table-column> -->
          <el-table-column :label="$t('message.ShouJianName')" prop="SJR"></el-table-column>
          <!-- <el-table-column :label="$t('message.Mark')" prop="MARK"></el-table-column> -->
          <!-- <el-table-column :label="$t('message.HuoWuCode')" prop="HWORDER"></el-table-column> -->
          <el-table-column :label="$t('message.HuoWuPc')" prop="HWSL"></el-table-column>
          <el-table-column :label="$t('message.HuoWuKg')" prop="HWZL"></el-table-column>
          <el-table-column :label="$t('message.HUoWuM')" prop="HWTJ"></el-table-column>
          <!-- <el-table-column :label="$t('message.KeHuCode')" prop="KHDM"></el-table-column> -->
          <el-table-column :label="$t('message.JiJianPeo')" prop="JJR"></el-table-column>
          <el-table-column :label="$t('message.JiJianPhone')" prop="JJRPHONE"></el-table-column>
          <el-table-column :label="$t('message.JiJianYouBian')" prop="JJRYB"></el-table-column>
          <el-table-column :label="$t('message.JiJianDiZhi')" prop="JJRDZ"></el-table-column>
          <el-table-column :label="$t('message.containerOrderRemark')" prop="REMARK"></el-table-column>
          <el-table-column :label="$t('message.signatureStateTitle')" prop="STATETEXT"></el-table-column>
          <el-table-column :label="$t('message.SystemOrderNum')" prop="PCORDER" min-width="100"></el-table-column>
		  
          <el-table-column :label="$t('message.orderTableTitle11')" prop="addTime" min-width="110" sortable="custom"></el-table-column>
          
          <el-table-column :label="$t('message.customTableTitle5')" min-width="100" fixed="right">
            <template slot-scope="scope">
              <a class="operation_a_blue" @click="checkLogistics(scope.row.ID)">{{$t('message.checkLogisticsText')}}</a>
            </template>
          </el-table-column>
          <el-table-column :label="$t('message.customTableTitle5')" width="100" fixed="right" >
            <template slot-scope="scope">
              <div class="operate_btn_box">
                <a target="_blank" :href="url + '/pdf/XBOrder?id=' + scope.row.ID">pdf</a>
                <el-button class="operation_btn delBtn" type="text" size="small" @click.native.prevent="delOrder(scope.row)"></el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page="page_no"
        :page-sizes="pageSizes"
        :page-size="page_size"
        layout="total, sizes, prev, pager, next"
        :total="totalSize"
        class="tablePage">
      </el-pagination>
    </div>
    <!-- 列表 -->
    <el-dialog :title="$t('message.importExcelTitle')" :visible.sync="uploadExcel" width="90%" destroy-on-close :close-on-click-modal="false">
      <div class="top_search_part">
        <div class="search_box">
          <a class="search_btn" style="color: #FFFFFF;" :href="imgSrc('Template.zip')">{{$t('message.downLoadExcel')}}</a>
        </div>
        <div class="search_box">
          <el-upload class="importBtnBox" :action="uploadUrl" :on-success="handleSuccess" :on-error="handleError" :limit="1" :on-change="uploadChange">
            <el-button class="search_btn">{{$t('message.selectExcel')}}</el-button>
          </el-upload>
          <el-button class="search_btn" @click="confirmImportExcel" :disabled="!this.excelTable">{{$t('message.confirmImportExcel')}}</el-button>
        </div>
      </div>
      <el-table id="excelTable" :data="excelTable" style="width: 100%" stripe size="small" header-cell-class-name="tableHeader" cell-class-name="tableBodyer">
        		
		<el-table-column :label="$t('message.ISCANDOOR')" prop="ISCANDOOR"></el-table-column>
		<el-table-column :label="$t('message.SENDTYPE')" prop="SENDTYPE"></el-table-column>
		<el-table-column :label="$t('message.CUSTOMERNO')" prop="CUSTOMERNO"></el-table-column>
		<el-table-column :label="$t('message.ShouJianPhone')" prop="SJRPHONE"></el-table-column>
		<el-table-column :label="$t('message.ShouJianYouBian')" prop="SJRYB"></el-table-column>
				
		<!-- <el-table-column :label="$t('message.HDS')" prop="HDS"></el-table-column>
		<el-table-column :label="$t('message.ShouJianYouBian')" prop="SJRYB"></el-table-column> -->
		<el-table-column :label="$t('message.ShouJianSheng')" prop="SJSHENG"></el-table-column>
		<!-- <el-table-column :label="$t('message.ShouJianShi')" prop="SJSHI"></el-table-column> -->
		<el-table-column :label="$t('message.ShouJianDiZhi')" prop="SJDIZHI"></el-table-column>
		<!-- <el-table-column :label="$t('message.ShouJianGongSi')" prop="SJGS"></el-table-column> -->
		<el-table-column :label="$t('message.ShouJianName')" prop="SJR"></el-table-column>
		
		<!-- <el-table-column :label="$t('message.Mark')" prop="MARK"></el-table-column> -->
		<!-- <el-table-column :label="$t('message.HuoWuCode')" prop="HWORDER"></el-table-column> -->
		<el-table-column :label="$t('message.HuoWuPc')" prop="HWSL"></el-table-column>
		<el-table-column :label="$t('message.HuoWuKg')" prop="HWZL"></el-table-column>
		<el-table-column :label="$t('message.HUoWuM')" prop="HWTJ"></el-table-column>
		<!-- <el-table-column :label="$t('message.KeHuCode')" prop="KHDM"></el-table-column> -->
		<el-table-column :label="$t('message.JiJianPeo')" prop="JJR"></el-table-column>
		<el-table-column :label="$t('message.JiJianPhone')" prop="JJRPHONE"></el-table-column>
		<el-table-column :label="$t('message.JiJianYouBian')" prop="JJRYB"></el-table-column>
		<el-table-column :label="$t('message.JiJianDiZhi')" prop="JJRDZ"></el-table-column>
		<el-table-column :label="$t('message.containerOrderRemark')" prop="REMARK"></el-table-column>
      </el-table>
    </el-dialog>
	<!-- 数据更新上传列表 -->
	<el-dialog :title="$t('message.UpdateExcelTitle')" :visible.sync="UpdateuploadExcel" width="90%" destroy-on-close :close-on-click-modal="false">
	  <div class="top_search_part">
	    <div class="search_box">
	      <el-upload class="importBtnBox" :action="UpdateuploadUrl" :on-success="UpdatehandleSuccess" :on-error="UpdatehandleError" :limit="1" :on-change="UpdateuploadChange">
	        <el-button class="search_btn">{{$t('message.selectExcel')}}</el-button>
	      </el-upload>
	      <el-button class="search_btn" @click="UpdateconfirmImportExcel" :disabled="!this.UpdateexcelTable">{{$t('message.confirmImportExcel')}}</el-button>
	    </div>
	  </div>
	  <el-table id="UpdateexcelTable" :data="UpdateexcelTable" style="width: 100%" stripe size="small" header-cell-class-name="tableHeader" cell-class-name="tableBodyer">	    		
		<el-table-column :label="$t('message.SystemOrderNum')" prop="PCORDER"></el-table-column>
		<el-table-column :label="$t('message.HuoWuCode')" prop="HWORDER"></el-table-column>
		<el-table-column :label="$t('message.HuoWuPc')" prop="HWSL"></el-table-column>
		<el-table-column :label="$t('message.HuoWuKg')" prop="HWZL"></el-table-column>
		<el-table-column :label="$t('message.HUoWuM')" prop="HWTJ"></el-table-column>
	  </el-table>
	</el-dialog>
    <!-- 查看物流信息 -->
    <el-dialog :title="$t('message.checkLogisticsText')" :visible.sync="checkLogisticsDialog"  width="50%" destroy-on-close :close-on-click-modal="false">
      <div class="dialog_box">
        <el-table id="logisticsList" :data="logisticsList" style="width: 100%" size="small" header-cell-class-name="tableHeader" cell-class-name="tableBodyer">
          <el-table-column :label="$t('message.deliverySituation')" prop="MESSAGE" min-width="170">
			  <template slot-scope="scope">
			    <span>{{scope.row.MESSAGE}}</span> <a v-if="scope.row.GUDING3!=null && scope.row.GUDING3!=''" :href="imgSrc(scope.row.GUDING3)" target="_blank">{{MESSAGE}}<img style="width: 20px;height: 20px; margin-left: 10px;" :src="imgSrc(scope.row.GUDING3)"></a>
			  </template>
		  </el-table-column>
          <el-table-column :label="$t('message.logisticsDate')" prop="ADDTIME" min-width="180"></el-table-column>
          <el-table-column :label="$t('message.customTableTitle5')" width="120" v-if="$store.state.JHSS.personalUserid.includes('administrator') || $store.state.JHSS.personalUserid === '231b7d38-893d-4f77-9821-bf668b81b86badmin'">
            <template slot-scope="scope">
              <el-button class="operation_btn" type="text" size="small" @click.native.prevent="delOrderLogistics(scope.row.ID, scope.row.PID)">{{$t('message.delOrderText')}}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import XLSX from 'xlsx'
  import { XiaoBaoGetAll,SetXiaoBaoImport, GetKdGuiJi,imgSrc, getOrderList, setOrder, delOrder, getUserData, setOrderState, uploadImg, readExcel, confirmImportExcel, setOrdersContainer, exportOrdersXiaoBao, HTTPS,getCustomer,SetXiaoBaoUpdateImport } from '@/api/getData.js'
  export default {
    name: 'ordersList',
    data () {
      return {
        page_no: 1,
        page_size: 10,
        pageSizes: [10, 20, 30, 50, 100],
        totalSize: 0,
        orderList: [],
        orderNum: '',
        orderSenderName: '',
        orderStatus:[],// [0, 1, 2],
		searchAcount:[this.$store.state.JHSS.personalUserid],
        orderAcountList:[],// 
        orderTime: null,
        orderSel: [], // 选中的订单
        orderProvince: [], // 收件省份
        orderSelProvince: '', // 收件省份选择
        remark: '',
        prop: null, // 排序字段
        order: '', // 排序方式，desc
        newOrder: false,
        newId: 0,
        // showOrderNumInput: false,
        newOrderNum: '',
        senderCompany: '',
        senderName: '',
        senderPhone: '',
        senderEmail: '',
        goodsNum: '',
        goodsWeight: '',
        goodsVolume: '',
        senderProvience: '',
        senderCity: '',
        senderAddress: '',
        addresseeProvience: '',
        addresseeCity: '',
        addressee: '',
        addresseeCompany: '',
        addresseeName: '',
        addresseePhone: '',
        // addresseeEmail: '',
        orderRemark: '',
        containerNumber: '',
        containerOrderModel: '',
        modelOptions: ['40GP/HQ', '20GP/HQ', 'CFS', 'NRT', 'KIX', 'HND'],
        arrivePort: '',
        cityOptions: ['東京', '大阪'],
        addOrderTitle: '',
        isAdmin: false,
        addresseeInfoList: [],
        prefecturesList: [],
        uploadExcel: false,
        excelNewFileName: '',
        excelTable: [],
        canConfirmImport: true,
        checkLogisticsDialog: false,
        logisticsList: [],
        selOrders: [],
        exportJson: {},
		
		UpdateexcelNewFileName :'',
		UpdateexcelTable: [],
		UpdateuploadExcel: false,
		UpdatecanConfirmImport: true,
		UpdateuploadUrl: ''
      }
    },
    created () {
      this.isAdmin = this.$store.state.JHSS.personalUserid.includes('admin')
      let param = this.$store.state.JHSS_xiaobaolist_param
      if (param.PAGE) this.page_no = param.PAGE
      if (param.TYPE) this.page_size = param.TYPE
      //if (param.UADDTIME && param.DADDTIME) this.orderTime = [param.UADDTIME, param.DADDTIME]
      //if (param.STATE) this.orderStatus = param.STATE.split(',').map(item => { return parseInt(item) })
	  
	  //获取本身账户及子账号
	  this.getCuetomer()
      // 查询订单列表
      this.getOrderList(param)
    },
    methods: {
      // 获取本身账户及子账号
      async getCuetomer () {
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading'
        })
        let param = { IFQUERY: '1',ADDUSERID:this.$store.state.JHSS.personalUserid }
        let res = await getCustomer(param)
        loading.close()
        if (res.status !== 200) {
          this.$message.error('network error：' + res.status)
          return
        } else {
          // console.log(res.data.dt)
          this.orderAcountList = res.data.dt.map(item => {
            return {
              label: item.USHOWNAME + '——' + item.GUDING1,
              value: item.USERID
            }
          })
        }
      },
      // 查询订单列表
      async getOrderList (param) {
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        param = param || {}
		if(this.searchAcount=="")
		{
			param.ADDUSERID = this.$store.state.JHSS.personalUserid
		}else{
			param.ADDUSERID = this.searchAcount.join(',')
		}
		if(param.ADDUSERID == null || param.ADDUSERID=="")
		{
			param.ADDUSERID = this.$store.state.JHSS.personalUserid
		}
		
        param.STATE = this.orderStatus.join(',')
        param.PAGE = this.page_no
        param.TYPE = this.page_size
        let res = await XiaoBaoGetAll(param)
        loading.close()
        if (res.status !== 200) {
          this.$message.error('network error：' + res.status)
          return
        }
        this.exportJson = param
        // console.log(res.data.ds)
        this.totalSize = res.data.num
        let index = (this.page_no - 1) * this.page_size
        let orderState2 = this.$t('message.orderState2')
        let orderState1 = this.$t('message.orderState1')
        let orderState0 = this.$t('message.orderState0')
        let orderState3 = this.$t('message.orderState3')
        this.orderList = res.data.dt.map(item => {
          item.index = ++index
          switch (item.STATE) {
            case '0':
              item.status = orderState0
              break
            case '1':
              item.status = orderState1
              break
            case '2':
              item.status = orderState2
              break
            default:
              item.status = orderState3
          }
          item.addTime = item.ADDTIME.replace(/T/g, ' ')
          return item
        })
        this.$store.commit('setOrderManageParam', param)
      },
      // 搜索订单编号
      searchOrderNum () {
        this.page_no = 1
        this.searchFun()
      },
      sizeChange (val) {
        // console.log(val)
        this.page_size = val
        this.page_no = 1
        this.searchFun()
      },
      currentChange (val) {
        // console.log(val)
        this.page_no = val
        this.searchFun()
      },
      searchFun () {
        let param = {}
        // 查询客户管理
        if (this.orderNum) {
          param.ORDERNUM = this.orderNum
        }
        if (this.orderSenderName) {
          param.JJR = this.orderSenderName
        }
        if (this.orderTime) {
          param.UADDTIME = this.orderTime[0]
          param.DADDTIME = this.orderTime[1]
        }
        if (this.remark) param.ORDERANDREMARK = this.remark
        this.getOrderList(param)
      },
      // 导出订单
      async exportOrders () {
        const message = this.$message({
          message: 'loading...',
          iconClass: 'el-icon-loading',
          duration: 0
        })
        let param = this.exportJson
        let res = await exportOrdersXiaoBao(param)
        message.close()
        if (res.status !== 200) {
          this.$message.error('network error：' + res.status)
        } else {
          // console.log(res.data)
          let str = HTTPS + "/xlsx/" + res.data
          window.open(str)
        }
      },
	  //批量打印
	  PrintMulOrders ()
	  {
        if (this.orderSel.length === 0) {
          this.$message(this.$t('message.signatureInsertTipsText'))
        } else {
			let AllId=""
			this.orderSel.map(item => {
				if(AllId==""){AllId=item.ID}else{AllId+=","+item.ID}
			})
			console.log(AllId);			
			window.open(this.url + '/pdf/XBOrder?ID=' +AllId)
		}		  
	  },
      addresseeInfoChange (val) {
        // console.log(val)
        this.addresseeProvience = this.addresseeInfoList[val].PROVINCE2
        this.addresseeCity = this.addresseeInfoList[val].CITY2
        this.addressee = this.addresseeInfoList[val].WLADDRESS
        this.addresseeCompany = this.addresseeInfoList[val].GSMC
        this.addresseeName = this.addresseeInfoList[val].LXR
        this.addresseePhone = this.addresseeInfoList[val].LXPHONE
      },
      // 删除订单
      delOrders () {
        // console.log(this.selOrders)
        let list = this.selOrders.map(item => {
          return item.ID
        })
        this.delOrder({ ID: list.join(',') })
      },
      delOrder (obj) {
        // console.log(obj)
        this.$confirm(this.$t('message.orderPrompt'), this.$t('message.promptTitle'), {
          confirmButtonText: this.$t('message.confirmText'),
          cancelButtonText: this.$t('message.cancleText')
        }).then(() => {
          this.del(obj.ID)
        }).catch(() => {
          this.$message(this.$t('message.canclePrompt'));
        });
      },
      async del (id) {
        let param = { ID: id }
        let res = await delOrder(param)
        if (res.status !== 200) {
          this.$message.error('network error：' + res.status)
          return
        }
        if (res.data.result !== '1') {
          this.$message.error(res.data.message)
        } else {
          // this.page_no = 1
          this.searchFun()
        }
      },
      // 查看物流信息
      async checkLogistics (id) {
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading'
        })
        let param = { KDID: id }
        console.log('param',param)
        let res = await GetKdGuiJi(param)
        loading.close()
        if (res.status !== 200) {
          this.$message.error('network error：' + res.status)
        } else {
          this.logisticsList = res.data.dt.map(item => {
            item.ADDTIME = item.ADDTIME.replace(/T/g, ' ')
            
            return item
          })
          this.checkLogisticsDialog = true
        }
      },
      // 时间排序
      sortChange (obj) {
        // console.log(obj)
        // 根据时间排序（prop: addTime ，order: 'ascending', 'descending', null）
        this.prop = null
        if (obj.prop === 'addTime') {
          this.prop = 'ADDTIME'
          // param.ORDERNAME = 'ADDTIME'
        }
        this.order = ''
        if (obj.order === 'descending') {
          this.order = 'DESC'
          // param.DOA = 'DESC'
        }
        // this.page_no = 1
        this.searchFun()
      },
      async cancel (id) {
        let param = { ID: id }
        let res = await setOrderState(param)
        if (res.status !== 200) {
          this.$message.error('network error：' + res.status)
          return
        }
        if (res.data.result !== '1') {
          this.$message.error(res.data.message)
        } else {
          // this.page_no = 1
          this.getOrderList()
        }
      },
	  //更新execl数据
	  UpdateExcel(){		  
		this.UpdateexcelNewFileName = ''
		this.UpdateexcelTable = []
		this.UpdateuploadExcel = true
		this.UpdatecanConfirmImport = true
	  },
      // 更新 上传成功
      UpdatehandleSuccess (file) {
        console.log('success', file)
        //this.importFile = file.data.filename
        //this.importFileOldName = file.data.fileoldname
      },
      UpdatehandleError (err) {
        console.log('UpdatehandleError:', err)
        this.importLoading.close()
        this.$message.error(err)
      },
      // 导入excle
      UpdateuploadChange (file)  {
        console.log('UpdateuploadChange:', file)
        // if (file.result !== '1') {
        //   this.$message.error(this.$t('message.importExcelError'))
        //   return
        // }
        //this.excelNewFileName = file.newFileName
		//开始读取
		const loading = this.$loading({
		  lock: true,
		  text: 'Loading',
		  spinner: 'el-icon-loading'
		})
		let _this = this
		let nameList = file.name.split('.')
		console.log('nameList：', nameList)
		const types = nameList[nameList.length - 1]
		const fileType = ['xlsx', 'xlc', 'xlm', 'xls', 'xlt', 'xlw', 'csv'].some(item => item === types)
		if (!fileType) {
		  loading.close()
		  this.$message(this.$t('message.uploadOrderFileError'))
		} else {
		  this.file2Xce(file).then(tabJson => {
		    loading.close()
		    if (tabJson && tabJson.length > 0) {
		      // this.xlsxJson = tabJson
		      console.log('导入数据：', tabJson[0].sheet)
		      this.UpdateexcelTable = tabJson[0].sheet.map(item => {
		        let obj = {
		          //ADDUSER: this.$store.state.JHSS.personalUserid,
		        }
				for(var key in item){
				     if(key.indexOf("GOFOR")>=0){ obj.PCORDER=item[key]; }
				     if(key.indexOf("客户管理单号")>=0||key.indexOf("番号")>=0){ obj.HWORDER=item[key]; }
				     if(key.indexOf("货物数量(pc)")>=0||key.indexOf("個数")>=0){ obj.HWSL=item[key]; }
				     if(key.indexOf("货物重量(kg)")>=0||key.indexOf("重量")>=0){ obj.HWZL=item[key]; }
				     if(key.indexOf("三边和")>=0||key.indexOf("三辺和")>=0){ obj.HWTJ=item[key]; }
				　　}				
		        return obj
		      })
		    } else {
		      this.$message(this.$t('message.uploadOrderNoFileError'))
		    }
		  })
		  
		}
		
      },
	  
	  
	  
	  
      // 导入excel
      importExcel () {
        this.excelNewFileName = ''
        this.excelTable = []
        this.uploadExcel = true
        this.canConfirmImport = true
      },
      beforeAvatarUpload (file) {
        // this.importLoading = this.$loading({
        //   lock: true,
        //   text: 'Loading',
        //   spinner: 'el-icon-loading',
        //   background: 'rgba(0, 0, 0, 0.7)'
        // })
      },
      // 上传成功
      handleSuccess (file) {
        console.log('success', file)
        //this.importFile = file.data.filename
        //this.importFileOldName = file.data.fileoldname
      },
      // 导入excle
      uploadChange (file)  {
        console.log('handleSuccess:', file)
        // if (file.result !== '1') {
        //   this.$message.error(this.$t('message.importExcelError'))
        //   return
        // }
        //this.excelNewFileName = file.newFileName
		//开始读取
		const loading = this.$loading({
		  lock: true,
		  text: 'Loading',
		  spinner: 'el-icon-loading'
		})
		let _this = this
		let nameList = file.name.split('.')
		const types = nameList[nameList.length - 1]
		const fileType = ['xlsx', 'xlc', 'xlm', 'xls', 'xlt', 'xlw', 'csv'].some(item => item === types)
		if (!fileType) {
		  loading.close()
		  this.$message(this.$t('message.uploadOrderFileError'))
		} else {
		  this.file2Xce(file).then(tabJson => {
		    loading.close()
		    if (tabJson && tabJson.length > 0) {
		      // this.xlsxJson = tabJson
		      //console.log('导入数据：', tabJson[0].sheet)
		      this.excelTable = tabJson[0].sheet.map(item => {
		        let obj = {
		          //ADDUSER: this.$store.state.JHSS.personalUserid,
		        }
				// //console.log('item：', item)
		  //       if (item['お届け先郵便番号'] != null) {									

		  //         obj.HDS = item['HDS貨物（YES/NO）']
		  //         obj.SJRYB = item['お届け先郵便番号']
		  //         obj.SJSHENG = item['お届け先住所１(都道府県)']
		  //         obj.SJSHI = item['お届け先住所２(市/郡)']
		  //         obj.SJDIZHI = item['お届け先住所３\n(区・町・丁目・番地・号)']
		  //         obj.SJGS = item['お届け先名称１ (会社名)']
		  //         obj.SJR = item['お届け先名称2 (名前)']
		  //         obj.SJRPHONE = item['お届け先電話番号']
		  //         obj.MARK = item['MARK']
		  //         obj.HWORDER = item['貨物番号']
		  //         obj.HWSL = item['個数(pc)']
		  //         obj.HWZL = item['重量(kg)']
		  //         obj.HWTJ = item['体積(m³)']
		  //         obj.KHDM = item['お客様コード']
		  //         obj.JJR = item['ご依頼主名称']
		  //         obj.JJRPHONE = item['ご依頼主電話番号']
		  //         obj.JJRYB = item['ご依頼主郵便番号']
		  //         obj.JJRDZ = item['ご依頼主住所']
		  //         obj.REMARK = item['備考']
		  //       }else{
				// 	 for(var key in item){
				// 	      if(key.indexOf("HDS货物")>=0){ obj.HDS=item[key]; }
				// 	      if(key.indexOf("收件人邮编")>=0){ obj.SJRYB=item[key]; }
				// 	      if(key.indexOf("收件省")>=0){ obj.SJSHENG=item[key]; }
				// 	      if(key.indexOf("收件市")>=0){ obj.SJSHI=item[key]; }
				// 	      if(key.indexOf("收件地址")>=0){ obj.SJDIZHI=item[key]; }
				// 	      if(key.indexOf("收件公司名")>=0){ obj.SJGS=item[key]; }
				// 	      if(key.indexOf("收件人姓名")>=0){ obj.SJR=item[key]; }
				// 	      if(key.indexOf("收件人电话")>=0){ obj.SJRPHONE=item[key]; }   
				// 	      if(key.indexOf("MARK")>=0){ obj.MARK=item[key]; }   
				// 	      if(key.indexOf("货物单号")>=0){ obj.HWORDER=item[key]; }  
				// 	      if(key.indexOf("货物数量")>=0){ obj.HWSL=item[key]; }  
				// 	      if(key.indexOf("货物重量")>=0){ obj.HWZL=item[key]; }  
				// 	      if(key.indexOf("货物体积")>=0){ obj.HWTJ=item[key]; }  
				// 	      if(key.indexOf("客户代码")>=0){ obj.KHDM=item[key]; }  
				// 	      if(key.indexOf("寄件人")>=0){ obj.JJR=item[key]; }  
				// 	      if(key.indexOf("寄件人电话")>=0){ obj.JJRPHONE=item[key]; }  
				// 	      if(key.indexOf("寄件人邮编")>=0){ obj.JJRYB=item[key]; }  
				// 	      if(key.indexOf("寄件人地址")>=0){ obj.JJRDZ=item[key]; }  
				// 	      if(key.indexOf("备注")>=0){ obj.REMARK=item[key]; }  
				// 	 　　}
					
				// } 
				
				for(var key in item){
				     if(key.indexOf("可以放在门口吗")>=0||key.indexOf("置き配可能かどうか")>=0){ obj.ISCANDOOR=item[key]; }
				     if(key.indexOf("派送方式")>=0||key.indexOf("配達方法")>=0){ obj.SENDTYPE=item[key]; }
				     if(key.indexOf("客户管理单号")>=0||key.indexOf("お客様管理番号")>=0){ obj.CUSTOMERNO=item[key]; }
				     if(key.indexOf("收件人邮编")>=0||key.indexOf("お届け先郵便番号")>=0){ obj.SJRYB=item[key]; }
				     if(key.indexOf("收件地址1")>=0||key.indexOf("お届け先住所１")>=0){ obj.SJSHENG=item[key]; }
				     // if(key.indexOf("收件市")>=0||key.indexOf("")>=0){ obj.SJSHI=item[key]; }
				     if(key.indexOf("收件地址2")>=0||key.indexOf("お届け先住所２")>=0){ obj.SJDIZHI=item[key]; }
				     // if(key.indexOf("收件公司名")>=0||key.indexOf("")>=0){ obj.SJGS=item[key]; }
				     if(key.indexOf("收件人姓名")>=0||key.indexOf("お届け先名")>=0){ obj.SJR=item[key]; }
				     if(key.indexOf("收件人电话")>=0||key.indexOf("お届け先電話番号")>=0){ obj.SJRPHONE=item[key]; }   
				     // if(key.indexOf("MARK")>=0||key.indexOf("")>=0){ obj.MARK=item[key]; }   
				     // if(key.indexOf("货物单号")>=0||key.indexOf("")>=0){ obj.HWORDER=item[key]; }  
				     if(key.indexOf("货物数量")>=0||key.indexOf("個数(")>=0){ obj.HWSL=item[key]; }  
				     if(key.indexOf("货物重量")>=0||key.indexOf("重量")>=0){ obj.HWZL=item[key]; }  
				     if(key.indexOf("货物三边和")>=0||key.indexOf("三辺和")>=0){ obj.HWTJ=item[key]; }  
				     // if(key.indexOf("客户代码")>=0||key.indexOf("")>=0){ obj.KHDM=item[key]; }  
				     if((key.indexOf("寄件人")>=0&&key.indexOf("寄件人电话")<0&&key.indexOf("寄件人邮编")<0&&key.indexOf("寄件人地址")<0)||key.indexOf("ご依頼主名称")>=0){ obj.JJR=item[key]; }  
				     if(key.indexOf("寄件人电话")>=0||key.indexOf("ご依頼主電話番号")>=0){ obj.JJRPHONE=item[key]; }  
				     if(key.indexOf("寄件人邮编")>=0||key.indexOf("ご依頼主郵便番号")>=0){ obj.JJRYB=item[key]; }  
				     if(key.indexOf("寄件人地址")>=0||key.indexOf("ご依頼主住所")>=0){ obj.JJRDZ=item[key]; }  
				     if(key.indexOf("备注")>=0||key.indexOf("備考")>=0){ obj.REMARK=item[key]; }  
				　　}
				
		  //       if (item['客户代码\r\nCustomer code'] != null) {				
					
		  //         obj.HDS = item['HDS货物（YES/NO）\r\nHDS GOODS（YES/NO）']
		  //         obj.SJRYB = item["收件人邮编\r\nRecipient's zip code"]
		  //         obj.SJSHENG = item['收件省\r\nReceiving province']
		  //         obj.SJSHI = item['收件市\r\nReceiving city']
		  //         obj.SJDIZHI = item['收件地址\r\nReceiving address']
		  //         obj.SJGS = item['收件公司名\r\nName of receiving company']
		  //         obj.SJR = item["收件人姓名\r\nRecipient's name"]
		  //         obj.SJRPHONE = item['收件人电话\r\nRecipient phone']
		  //         obj.MARK = item['MARK']
		  //         obj.HWORDER = item['货物单号\r\nCargo order number']
		  //         obj.HWSL = item['货物数量(pc)\r\nNumber of items(pc)']
		  //         obj.HWZL = item['货物重量(kg)\r\nItem weighing(kg)']
		  //         obj.HWTJ = item['货物体积(m³)\r\nItem volume(m³)']
		  //         obj.KHDM = item['客户代码\r\nCustomer code']
		  //         obj.JJR = item["寄件人\r\nSender's name"]
		  //         obj.JJRPHONE = item["寄件人电话\r\nSender's phone number"]
		  //         obj.JJRYB = item["寄件人邮编\r\nSender's zip code"]
		  //         obj.JJRDZ = item["寄件人地址\r\nSender's address"]
		  //         obj.REMARK = item['备注\r\nRemarks']?"":item['备注\r\nRemarks']
				// }
		        return obj
		      })
		    } else {
		      this.$message(this.$t('message.uploadOrderNoFileError'))
		    }
		  })
		  
		}
		
      },
      handleError (err) {
        this.importLoading.close()
        // console.log('handleError:', err, file)
        this.$message.error(err)
      },
      // 解析excel
      file2Xce (file) {
        return new Promise(function(resolve, reject) {
          const reader = new FileReader()
          reader.onload = function(e) {
            const data = e.target.result
            this.wb = XLSX.read(data, {
              type: 'binary'
            })
            const result = []
            this.wb.SheetNames.forEach((sheetName) => {
              result.push({
                sheetName: sheetName,
                sheet: XLSX.utils.sheet_to_json(this.wb.Sheets[sheetName])
              })
            })
            resolve(result)
          }
          reader.readAsBinaryString(file.raw)
          // reader.readAsBinaryString(file) // 传统input方法
        })
      },
	  //确定更新导入数据
	  async UpdateconfirmImportExcel(){		  
		    const loading = this.$loading({
		      lock: true,
		      text: 'Loading',
		      spinner: 'el-icon-loading',
		      background: 'rgba(0, 0, 0, 0.7)'
		    })
		    let param = this.UpdateexcelTable.map(item => {
		      item.EDITUSER = this.$store.state.JHSS.personalUserid
		      return item
		    })
		  		let obj = {
		  		  USERID: this.$store.state.JHSS.personalUserid,
		  		  Lst:param
		  		}
		  		
		    let res = await SetXiaoBaoUpdateImport(obj)
		    loading.close()
		    if (res.status !== 200) {
		      this.$message.error('network error：' + res.status)
		    } else if (res.data.result !== '1') {
		      this.$message.error(res.data.message)
		    } else {
		    }		
		    this.UpdateuploadExcel = false
		    this.page_no = 1
		    // 查询订单列表
		    this.getOrderList()
	  },
      // 确定导入数据
      async confirmImportExcel () {
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        let param = this.excelTable.map(item => {
          item.ADDUSER = this.$store.state.JHSS.personalUserid
          return item
        })
		let obj = {
		  USERID: this.$store.state.JHSS.personalUserid,
		  Lst:param
		}
		
        let res = await SetXiaoBaoImport(obj)
        loading.close()
        if (res.status !== 200) {
          this.$message.error('network error：' + res.status)
        } else if (res.data.result !== '1') {
          //this.$message.error(res.data.message)
				//this.$message({   message: '警告哦，这是一条警告消息',  duration: 0,   showClose: true,  type: 'warning'})
		      //this.$message.error(res.data.message)
				this.option = this.$message({
		          message: res.data.message,
		          type: "warning",
		          duration:0,   
				  showClose: true
		        });
        } else {
        }		
        this.uploadExcel = false
        this.page_no = 1
        // 查询订单列表
        this.getOrderList()
      },
      imgSrc (name) {
        return imgSrc(name)
      },
      // 选择订单
      selectionChange (val) {
        this.selOrders = val
        this.orderSel = val
      }
    },
    computed: {
      uploadUrl () {
        return uploadImg()
      },
      url () {
        return HTTPS
      }
    }
  }
</script>

<style scoped>
.main_top_search {
  /* height: 180px; */
  height: 126px;
  flex-wrap: wrap;
}
.main_top_search :first-child {
  flex-wrap: wrap;
  flex-shrink: 1;
}
.main_top_search :first-child .search_item, .main_top_search :first-child .search_btn, .main_top_search :first-child .add_btn {
  /* margin-bottom: 10px; */
  margin-top: 10px;
}
.importBtnBox {
  flex-shrink: 0;
  height: 44px;
  border-radius: 4px;
  font-size: 16px;
  color: #FFFFFF;
  line-height: 44px;
  margin-left: 28px;
  cursor: pointer;
  padding: 0 20px;
  display: flex;
  align-items: center;
}
.importBtn {
  flex-shrink: 0;
  display: inline-block;
  height: 44px;
  background: #0066FF;
  border-radius: 4px;
  font-size: 16px;
  color: #FFFFFF;
  line-height: 44px;
  margin: 0 28px;
  cursor: pointer;
  padding: 0 20px;
}
.barCodeImg {
  width: 52px;
  height: 41px;
}
.addItemInput, .addresseeInput {
  min-height: 46px;
  border: 1px solid #979797;
  border-radius: 4px;
  padding: 0 11px;
  font-size: 18px;
  color: #666666;
  text-align: left;
}
.addItemInput {
  width: 197px;
}
.addItemSelect {
  width: 197px;
  min-height: 46px;
}
.addresseeInput {
  width: 525px;
}
.remarkInput {
  width: 650px;
  min-height: 46px;
  font-size: 18px;
  color: #666666;
  text-align: left !important;
}
/deep/ .remarkInput .el-textarea__inner {
  text-align: left;
}
.checkBtn {
  border: 0;
  font-size: 18px;
  color: #0066FF;
}


/* 导入文件 */
.importLine {
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
</style>
